var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.334h512v341.337H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.334h256v170.663H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#d80027"
}, /*#__PURE__*/React.createElement("path", {
  d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 85.329v15.083l57.377 38.251H80z"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
  fill: "#2e52b2"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M256 85.329v15.083l-57.377 38.251H176z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
  fill: "#2e52b2"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.329v15.083l57.377 38.251H80z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
  fill: "#2e52b2"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M256 85.329v15.083l-57.377 38.251H176z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
  fill: "#2e52b2"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 255.997v-15.082l57.377-38.252H80z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M0 233.376v-30.713h46.069zm96 22.618v-48.912l-73.372 48.912z",
  fill: "#2e52b2"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M256 255.997v-15.082l-57.377-38.252H176z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M256 233.376v-30.713h-46.069zm-96 22.618v-48.912l73.372 48.912z",
  fill: "#2e52b2"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M332.058 189.214v81.623c0 39.76 103.884 39.76 103.884 0v-81.623H332.058z",
  fill: "#f3f3f3"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M332.058 270.837c0 39.76 51.942 51.942 51.942 51.942s51.942-12.182 51.942-51.942v.001H332.058v-.001z",
  fill: "#6da544"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#a2001d",
  d: "M384 238.188l-24.116 10.388v22.261L384 285.678l24.116-14.841v-22.261z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#338af3",
  d: "M359.88 226.312h48.228v22.261H359.88z"
})));

export default SvgBm;